import { request } from "../@utils";
import { requestFile } from "../@utils";
const PriceService = {
  batchUpdateProductPrice: async (params) => {
    const res = await request.post("/product/price/batch-update-price",{ data: params });
    return res;
  },
  getPricePageList: async (params) => {
    const res = await request.post("/product/price/page",{ data: params });
    return res;
  },
  getUpdateRecord: async (params) => {
    const res = await request.post("/product/price/view-update-record",{ data: params });
    return res;
  },
  exportProductPrice: async (params) => {
    const res = await requestFile.post("/product/price/export",{ data: params, responseType: "blob" });
    return res;
  },
  addFileTask: async params => {
    const res = await request.post('/product/price/import-price', { data: params })
    return res
  },
  //调价审核
  getPriceAuditList: async (params) => {
    const res = await request.post("/product/price-adjust/page",{ data: params });
    return res;
  },
  batchPassPriceAudit: async (params) => {
    const res = await request.post("/product/price-adjust/batch/pass",{ data: params });
    return res;
  },
  batchRejectPriceAudit: async (params) => {
    const res = await request.post("/product/price-adjust/batch/reject",{ data: params });
    return res;
  },
  passPriceAudit: async (params) => {
    const res = await request.post("/product/price-adjust/pass",{ data: params });
    return res;
  },
  rejectPriceAudit: async (params) => {
    const res = await request.post("/product/price-adjust/reject",{ data: params });
    return res;
  },
};
export default PriceService;